// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../../../public/images/otc_service-img/otc_servicebg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../../../public/images/otc_service-img/octdesk_cta.jpg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `

.otc-service-page {
    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;
    background-color: #FFFFFF;
    color: #111827;
    padding: 0px 0 100px 0;
    position: relative;
    overflow: hidden;
}

.otc-service-container {
    max-width: 1480px;
    margin: 0 auto;
    padding: 0 20px;
    position: relative;
    z-index: 1;
}

.gold-text {
    color: #D3B06C;
    font-weight: 700;
}

/* ==========================================================================
   1. HERO SECTION
   ========================================================================== */
.otc_hero_section {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center center / cover;
    width: 100%;
    margin-bottom: 70px;
    padding: 20px 0;
    position: relative;
    overflow: hidden;
}

.otc-service-hero {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 40px;
    position: relative;
    padding: 0px;
    background: transparent;
}

.otc-service-hero-left {
    flex: 1 1;
    max-width: 580px;
}

.otc-service-hero-title {
    font-size: 70px;
    font-weight: 700;
    color: #111827;
    line-height: 1.12;
    margin: 0 0 18px 0;
}

.otc-service-hero-desc {
    font-size: 22px;
    color: #6B7280;
    line-height: 1.6;
    margin: 0 0 36px 0;
    max-width: 650px;
}

.otc-service-hero-btns {
    display: flex;
    align-items: center;
    gap: 12px;
}

.otc-service-hero-btns a {
    font-size: 18px;
    border-radius: 50px;
    padding: 14px 38px;
}

.btn-contact-us {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    background-color: #D3B06C;
    color: #FFFFFF;
    font-weight: 600;
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.3);
    transition: all 0.25s ease;
    text-decoration: none;
}

.btn-contact-us:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.4);
    color: #FFFFFF;
}

.link-learn-more {
    font-weight: 600;
    color: #374151;
    text-decoration: none;
    display: inline-flex;
    align-items: center;
    gap: 6px;
    transition: color 0.2s ease;
}

.link-learn-more:hover {
    color: #D3B06C;
}

.otc-service-hero-right {
    width: 700px;
    max-width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
}

.otc-service-hero-right img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
}


/* ==========================================================================
   2. OUR OTC SERVICES MINI CARDS BAR
   ========================================================================== */
.our-otc-services-section {
    margin-bottom: 70px;
}

.our-otc-title {
    font-size: 40px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 24px 0;
}

.mini-services-grid {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
    gap: 16px;
    margin-bottom: 40px;
}

.mini-service-card {
    background-color: #ffff;
    border: 1px solid #F3F4F6;
    border-radius: 18px;
    box-shadow: 0px 0px 10px #99999926;
    padding: 18px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 10px;
    text-align: center;
    transition: all 0.2s ease;
}

.mini-service-card:hover {
    background-color: #FFFFFF;
    border-color: #FDE68A;
    box-shadow: 0 4px 15px rgba(211, 176, 108, 0.12);
    transform: translateY(-2px);
}

.mini-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 16px;
    background-color: #FFF2DB;
    display: flex;
    align-items: center;
    justify-content: center;
}

.mini-icon-box img {
    width: 20px;
    height: 20px;
    object-fit: contain;
}

.otcservices_list {
    width: 100%;
    display: block;
    padding: 60px 0px;
    background-color: #F9FAFB;
}

.mini-service-card span {
    font-size: 14px;
    font-weight: 700;
    color: #111827;
}


/* ==========================================================================
   3. DETAILED SERVICES GRID (6 FEATURE CARDS)
   ========================================================================== */
.detailed-services-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 24px;
    margin-bottom: 0px;
}

.service-feature-card {
    background-color: #FFFFFF;
    border: 1px solid #F3F4F6;
    border-radius: 20px;
    padding: 32px;
    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);
    transition: transform 0.25s ease, box-shadow 0.25s ease;
}

.service-feature-card:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);
    border-color: #FDE68A;
}

.feature-icon-box {
    width: 48px;
    height: 48px;
    border-radius: 15px;
    background-color: #D1AA67;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
}

.feature-icon-box img {
    width: 24px;
    height: 24px;
    object-fit: contain;
}

.service-feature-card h3 {
    font-size: 16px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 10px 0;
}

.service-feature-card p {
    font-size: 14px;
    color: #6B7280;
    line-height: 1.55;
    margin: 0;
}


/* ==========================================================================
   4. OTC SERVICE PROCESS
   ========================================================================== */
.otc-process-section {
    position: relative;
    justify-content: end;
    align-items: end;
    border-radius: 0px;
    min-height: 640px;
    background: linear-gradient(90deg, rgba(239, 235, 228, 1) 0%, rgba(255, 255, 255, 1) 49%, rgba(239, 235, 228, 1) 100%);
    padding: 60px 0 0px 0;
    margin-bottom: 90px;
    border-radius: 0px;
    display: flex;
    flex-direction: column;
}

.process-title {
    font-size: 32px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 36px 0px;
}

.process-grid-4col {
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    gap: 20px;
    padding: 0px;
}

.otc-process-section .process-card {
    background-color: #fff;
    border: 1px solid #F3F4F6;
    border-radius: 20px;
    position: relative;
    padding: 28px 24px;
    box-shadow: 0 4px 15px rgb(0 0 0 / 8%);
    transition: transform 0.25s ease;
    text-align: left;
    align-items: start;
}

.otc-process-section .process-card:hover {
    transform: translateY(-3px);
}

.otc-process-section .process-num {
    font-size: 36px;
    font-weight: 800;
    color: #D1AA67;
    margin-bottom: 12px;
    font-weight: 800;
    color: #D3B06C;
    margin-bottom: 12px;
}

.process-card h4 {
    font-size: 15px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 8px 0;
}

.process-card p {
    font-size: 13.5px;
    color: #6B7280;
    line-height: 1.5;
    margin: 0;
}


/* ==========================================================================
   5. CTA BANNER ("Partner with a Trusted OTC Desk")
   ========================================================================== */
.partner-cta-section {
    margin-bottom: 20px;
}

.partner-cta-card {
    background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center center / cover, #FFFDF8;
    border: 1px solid #8b6b352e;
    border-radius: 24px;
    padding: 50px 30px;
    min-height: 282px;
    text-align: center;
    box-shadow: 0 1px 12px rgb(0 0 0 / 15%);
}

.partner-cta-card h2 {
    font-size: 28px;
    font-weight: 700;
    color: #111827;
    margin: 0 0 12px 0;
}

.partner-cta-card p {
    font-size: 15px;
    color: #6B7280;
    max-width: 600px;
    margin: 0 auto 28px auto;
    line-height: 1.6;
}

.btn-contact-desk {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 14px 36px;
    background-color: #D1AA67;
    color: #FFFFFF;
    font-size: 15px;
    font-weight: 600;
    border: none;
    border-radius: 50px;
    cursor: pointer;
    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.3);
    transition: all 0.25s ease;
    text-decoration: none;
}

.btn-contact-desk:hover {
    background-color: #C09D5B;
    transform: translateY(-2px);
    color: #fff;
}


/* ==========================================================================
   RESPONSIVE ADJUSTMENTS
   ========================================================================== */
@media (max-width: 1500px) {

    .otc-service-container {
        max-width: 95%;
    }

    .otc-service-hero-title {
        font-size: 60px;
    }

}


@media (max-width: 1200px) {


    .otc-service-hero-right {
        width: 450px;
        max-width: 100%;
        justify-content: center;
    }

    .otc-service-hero-title {
        font-size: 48px;
    }

    .otc-service-hero-desc {
        font-size: 16px;
        margin: 0 0 24px 0;
    }

    .otc-service-hero-btns a {
        font-size: 14px;
        padding: 10px 28px;
    }

    .our-otc-title {
        font-size: 32px;
    }


    .otc-process-section {
        min-height: 500px;
    }


}

@media (max-width: 768px) {


    .detailed-services-grid {
        grid-template-columns: 1fr 1fr;
    }


    .process-grid-4col {
        grid-template-columns: 1fr 1fr;
    }

    .otc-service-hero-title {
        font-size: 38px;
    }

    .mini-services-grid {
        grid-template-columns: repeat(3, 1fr);
    }

    .detailed-services-grid {
        grid-template-columns: 1fr;
    }

    .process-grid-4col {
        grid-template-columns: 1fr 1fr;
    }

    .otc-service-hero-right {
        width: 330px;
    }

    .otc-process-section {
        min-height: 500px;
        margin-bottom: 40px;
        padding-top: 40px;
    }

    .otc-service-hero-title {
        font-size: 32px;
        margin-bottom: 15px;
    }

    .otc-service-hero-desc {
        font-size: 15px;
        margin: 0 0 20px 0;
    }

    .otc_hero_section {
        margin-bottom: 35px;
    }

    .our-otc-title {
        font-size: 24px;
    }

    .detailed-services-grid {
        grid-template-columns: 1fr 1fr;
    }

    .otc-service-container {
        width: 100%;
    }

    .process-title {
        font-size: 24px;
        margin: 0 0 20px 0px;
    }

    .otc-process-section .process-num {
        font-size: 36px;
        position: absolute;
        left: 19px;
        top: 14px;
        margin: 0px;
        color: #d3b06ca6;
    }

    .otc-process-section .process-card h4 {
        padding-left: 48px;
        font-size: 18px;
    }

    .otc-process-section .process-card p {
        font-size: 14px;
        padding-left: 50px;
    }

    .otc-process-section .process-card {
        border-radius: 15px;
        padding: 24px;
    }

}

@media (max-width: 767px) {

    .otc-service-hero {
        flex-direction: column;
        text-align: center;
        gap: 20px;
        padding: 30px 0px 0px;
    }

    .otc-service-hero-title {
        font-size: 26px;
    }

    .otc-service-hero-desc {
        margin: 0 0 15px 0;
    }

    .otc-service-hero-btns {
        justify-content: center;
    }

    .otc-service-hero-right {
        width: 300px;
    }

    .otc_hero_section {
        margin-bottom: 30px;
    }

    .our-otc-services-section {
        margin-bottom: 40px;
    }

    .otcservices_list {
        padding: 35px 0px;
    }

    .service-feature-card {
        padding: 22px;
    }

    .partner-cta-card h2 {
        font-size: 24px;
    }

    .btn-contact-desk {
        padding: 10px 30px;
        font-size: 13px;
    }

    .otc-service-page {
        padding: 0px 0 30px 0;
    }


}


@media (max-width:480px) {

    .mini-services-grid {
        grid-template-columns: repeat(2, 1fr);
    }

    .feature-icon-box {
        width: 38px;
        height: 38px;
        border-radius: 10px;
        margin: 0 auto;
    }

    .partner-cta-card p {
        font-size: 14px;
        margin: 0 auto 15px auto;
    }

    .service-feature-card h3 {
        margin: 18px 0 5px 0;
    }

    .mini-icon-box {
        width: 38px;
        height: 38px;
        border-radius: 10px;
    }

    .otc-process-section {
        padding-top: 30px;
    }

    .process-title {
        font-size: 22px;
        margin: 0 0 16px 0px;
    }

    .otc-process-section .process-num {
        font-size: 32px;
    }

    .service-feature-card {
        text-align: center;
    }

    .detailed-services-grid {
        grid-template-columns: 1fr;
        gap: 18px;

    }

    .our-otc-title {
        font-size: 22px;
        margin-bottom: 15px;
    }

    .process-grid-4col {
        grid-template-columns: 1fr;
    }

    .partner-cta-card {
        border-radius: 18px;
        padding: 36px 24px;
        min-height: 100%;
    }

    .partner-cta-card h2 {
        font-size: 22px;
        margin: 0 0 8px 0;
    }

}

body:not(.light_theme) .otc-service-page {
    background-color: #181a20;
    color: #eaecef;
}

body:not(.light_theme) .otc_hero_section,
body:not(.light_theme) .partner-cta-card {
    background-color: #181a20;
    background-image: none;
}

body:not(.light_theme) .otc_hero_section::before {
    content: "";
    position: absolute;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background:
        repeating-conic-gradient(
            from -18deg at 72% -8%,
            rgba(211, 176, 108, 0.18) 0deg 3.5deg,
            transparent 3.5deg 12deg
        ),
        radial-gradient(ellipse 70% 50% at 70% 0%, rgba(211, 176, 108, 0.22) 0%, rgba(24, 26, 32, 0) 68%);
}

body:not(.light_theme) .otc-service-hero-title,
body:not(.light_theme) .our-otc-title,
body:not(.light_theme) .process-title,
body:not(.light_theme) .partner-cta-card h2,
body:not(.light_theme) .service-feature-card h3,
body:not(.light_theme) .mini-service-card span,
body:not(.light_theme) .process-card h4 {
    color: #eaecef;
}

body:not(.light_theme) .otc-service-hero-desc,
body:not(.light_theme) .link-learn-more,
body:not(.light_theme) .service-feature-card p,
body:not(.light_theme) .partner-cta-card p,
body:not(.light_theme) .process-card p {
    color: #84888c;
}

body:not(.light_theme) .mini-service-card,
body:not(.light_theme) .service-feature-card,
body:not(.light_theme) .otc-process-section .process-card {
    background-color: #1e2329;
    border-color: #2b3139;
    box-shadow: none;
}

body:not(.light_theme) .mini-service-card:hover {
    background-color: #252a34;
    border-color: #d3b06c;
}

body:not(.light_theme) .otcservices_list {
    background-color: #0b0e11;
}

body:not(.light_theme) .otc-process-section {
    background: linear-gradient(90deg, #1a1610 0%, #181a20 49%, #1a1610 100%);
}

body:not(.light_theme) .mini-icon-box {
    background-color: #2b2418;
}

body:not(.light_theme) .partner-cta-card {
    background-color: #1e2329;
    border-color: #2b3139;
}`, "",{"version":3,"sources":["webpack://./src/ui/Pages/OtcService/otc-service.css"],"names":[],"mappings":";;AAEA;IACI,oEAAoE;IACpE,yBAAyB;IACzB,cAAc;IACd,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;IACf,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,cAAc;IACd,gBAAgB;AACpB;;AAEA;;+EAE+E;AAC/E;IACI,mFAA8G;IAC9G,WAAW;IACX,mBAAmB;IACnB,eAAe;IACf,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,SAAS;IACT,kBAAkB;IAClB,YAAY;IACZ,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,yBAAyB;IACzB,cAAc;IACd,gBAAgB;IAChB,YAAY;IACZ,eAAe;IACf,+CAA+C;IAC/C,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,+CAA+C;IAC/C,cAAc;AAClB;;AAEA;IACI,gBAAgB;IAChB,cAAc;IACd,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,YAAY;IACZ,eAAe;IACf,aAAa;IACb,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,mBAAmB;AACvB;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;IACvB,yBAAyB;IACzB,mBAAmB;IACnB,kCAAkC;IAClC,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,SAAS;IACT,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gDAAgD;IAChD,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;IACjB,yBAAyB;AAC7B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;;AAGA;;+EAE+E;AAC/E;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,kBAAkB;AACtB;;AAEA;IACI,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,0CAA0C;IAC1C,uDAAuD;AAC3D;;AAEA;IACI,2BAA2B;IAC3B,0CAA0C;IAC1C,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,kBAAkB;IAClB,oBAAoB;IACpB,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;IACjB,sHAAsH;IACtH,qBAAqB;IACrB,mBAAmB;IACnB,kBAAkB;IAClB,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,YAAY;AAChB;;AAEA;IACI,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;IAClB,kBAAkB;IAClB,sCAAsC;IACtC,gCAAgC;IAChC,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,gBAAgB;IAChB,SAAS;AACb;;;AAGA;;+EAE+E;AAC/E;IACI,mBAAmB;AACvB;;AAEA;IACI,4FAAqH;IACrH,2BAA2B;IAC3B,mBAAmB;IACnB,kBAAkB;IAClB,iBAAiB;IACjB,kBAAkB;IAClB,uCAAuC;AAC3C;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,gBAAgB;IAChB,wBAAwB;IACxB,gBAAgB;AACpB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,eAAe;IACf,+CAA+C;IAC/C,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,2BAA2B;IAC3B,WAAW;AACf;;;AAGA;;+EAE+E;AAC/E;;IAEI;QACI,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;AAEJ;;;AAGA;;;IAGI;QACI,YAAY;QACZ,eAAe;QACf,uBAAuB;IAC3B;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;;IAGA;QACI,iBAAiB;IACrB;;;AAGJ;;AAEA;;;IAGI;QACI,8BAA8B;IAClC;;;IAGA;QACI,8BAA8B;IAClC;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,qCAAqC;IACzC;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,iBAAiB;QACjB,mBAAmB;QACnB,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;QACf,kBAAkB;QAClB,UAAU;QACV,SAAS;QACT,WAAW;QACX,gBAAgB;IACpB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;QACnB,aAAa;IACjB;;AAEJ;;AAEA;;IAEI;QACI,sBAAsB;QACtB,kBAAkB;QAClB,SAAS;QACT,qBAAqB;IACzB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,YAAY;IAChB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,qBAAqB;IACzB;;;AAGJ;;;AAGA;;IAEI;QACI,qCAAqC;IACzC;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;QACnB,cAAc;IAClB;;IAEA;QACI,eAAe;QACf,wBAAwB;IAC5B;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,mBAAmB;IACvB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,eAAe;QACf,oBAAoB;IACxB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,0BAA0B;QAC1B,SAAS;;IAEb;;IAEA;QACI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,0BAA0B;IAC9B;;IAEA;QACI,mBAAmB;QACnB,kBAAkB;QAClB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,iBAAiB;IACrB;;AAEJ;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;;IAEI,yBAAyB;IACzB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,oBAAoB;IACpB,UAAU;IACV;;;;;;yGAMqG;AACzG;;AAEA;;;;;;;IAOI,cAAc;AAClB;;AAEA;;;;;IAKI,cAAc;AAClB;;AAEA;;;IAGI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yEAAyE;AAC7E;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB","sourcesContent":["\n\n.otc-service-page {\n    font-family: 'Inter', 'Outfit', system-ui, -apple-system, sans-serif;\n    background-color: #FFFFFF;\n    color: #111827;\n    padding: 0px 0 100px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.otc-service-container {\n    max-width: 1480px;\n    margin: 0 auto;\n    padding: 0 20px;\n    position: relative;\n    z-index: 1;\n}\n\n.gold-text {\n    color: #D3B06C;\n    font-weight: 700;\n}\n\n/* ==========================================================================\n   1. HERO SECTION\n   ========================================================================== */\n.otc_hero_section {\n    background: url('../../../../public/images/otc_service-img/otc_servicebg.png') no-repeat center center / cover;\n    width: 100%;\n    margin-bottom: 70px;\n    padding: 20px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n.otc-service-hero {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    gap: 40px;\n    position: relative;\n    padding: 0px;\n    background: transparent;\n}\n\n.otc-service-hero-left {\n    flex: 1;\n    max-width: 580px;\n}\n\n.otc-service-hero-title {\n    font-size: 70px;\n    font-weight: 700;\n    color: #111827;\n    line-height: 1.12;\n    margin: 0 0 18px 0;\n}\n\n.otc-service-hero-desc {\n    font-size: 22px;\n    color: #6B7280;\n    line-height: 1.6;\n    margin: 0 0 36px 0;\n    max-width: 650px;\n}\n\n.otc-service-hero-btns {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.otc-service-hero-btns a {\n    font-size: 18px;\n    border-radius: 50px;\n    padding: 14px 38px;\n}\n\n.btn-contact-us {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    background-color: #D3B06C;\n    color: #FFFFFF;\n    font-weight: 600;\n    border: none;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.3);\n    transition: all 0.25s ease;\n    text-decoration: none;\n}\n\n.btn-contact-us:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    box-shadow: 0 6px 20px rgba(211, 176, 108, 0.4);\n    color: #FFFFFF;\n}\n\n.link-learn-more {\n    font-weight: 600;\n    color: #374151;\n    text-decoration: none;\n    display: inline-flex;\n    align-items: center;\n    gap: 6px;\n    transition: color 0.2s ease;\n}\n\n.link-learn-more:hover {\n    color: #D3B06C;\n}\n\n.otc-service-hero-right {\n    width: 700px;\n    max-width: 100%;\n    display: flex;\n    justify-content: flex-end;\n    align-items: center;\n}\n\n.otc-service-hero-right img {\n    max-width: 100%;\n    height: auto;\n    object-fit: contain;\n}\n\n\n/* ==========================================================================\n   2. OUR OTC SERVICES MINI CARDS BAR\n   ========================================================================== */\n.our-otc-services-section {\n    margin-bottom: 70px;\n}\n\n.our-otc-title {\n    font-size: 40px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 24px 0;\n}\n\n.mini-services-grid {\n    display: grid;\n    grid-template-columns: repeat(5, 1fr);\n    gap: 16px;\n    margin-bottom: 40px;\n}\n\n.mini-service-card {\n    background-color: #ffff;\n    border: 1px solid #F3F4F6;\n    border-radius: 18px;\n    box-shadow: 0px 0px 10px #99999926;\n    padding: 18px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 10px;\n    text-align: center;\n    transition: all 0.2s ease;\n}\n\n.mini-service-card:hover {\n    background-color: #FFFFFF;\n    border-color: #FDE68A;\n    box-shadow: 0 4px 15px rgba(211, 176, 108, 0.12);\n    transform: translateY(-2px);\n}\n\n.mini-icon-box {\n    width: 48px;\n    height: 48px;\n    border-radius: 16px;\n    background-color: #FFF2DB;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.mini-icon-box img {\n    width: 20px;\n    height: 20px;\n    object-fit: contain;\n}\n\n.otcservices_list {\n    width: 100%;\n    display: block;\n    padding: 60px 0px;\n    background-color: #F9FAFB;\n}\n\n.mini-service-card span {\n    font-size: 14px;\n    font-weight: 700;\n    color: #111827;\n}\n\n\n/* ==========================================================================\n   3. DETAILED SERVICES GRID (6 FEATURE CARDS)\n   ========================================================================== */\n.detailed-services-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 24px;\n    margin-bottom: 0px;\n}\n\n.service-feature-card {\n    background-color: #FFFFFF;\n    border: 1px solid #F3F4F6;\n    border-radius: 20px;\n    padding: 32px;\n    box-shadow: 0 2px 10px rgba(0, 0, 0, 0.02);\n    transition: transform 0.25s ease, box-shadow 0.25s ease;\n}\n\n.service-feature-card:hover {\n    transform: translateY(-4px);\n    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.06);\n    border-color: #FDE68A;\n}\n\n.feature-icon-box {\n    width: 48px;\n    height: 48px;\n    border-radius: 15px;\n    background-color: #D1AA67;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-bottom: 20px;\n}\n\n.feature-icon-box img {\n    width: 24px;\n    height: 24px;\n    object-fit: contain;\n}\n\n.service-feature-card h3 {\n    font-size: 16px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 10px 0;\n}\n\n.service-feature-card p {\n    font-size: 14px;\n    color: #6B7280;\n    line-height: 1.55;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   4. OTC SERVICE PROCESS\n   ========================================================================== */\n.otc-process-section {\n    position: relative;\n    justify-content: end;\n    align-items: end;\n    border-radius: 0px;\n    min-height: 640px;\n    background: linear-gradient(90deg, rgba(239, 235, 228, 1) 0%, rgba(255, 255, 255, 1) 49%, rgba(239, 235, 228, 1) 100%);\n    padding: 60px 0 0px 0;\n    margin-bottom: 90px;\n    border-radius: 0px;\n    display: flex;\n    flex-direction: column;\n}\n\n.process-title {\n    font-size: 32px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 36px 0px;\n}\n\n.process-grid-4col {\n    display: grid;\n    grid-template-columns: repeat(4, 1fr);\n    gap: 20px;\n    padding: 0px;\n}\n\n.otc-process-section .process-card {\n    background-color: #fff;\n    border: 1px solid #F3F4F6;\n    border-radius: 20px;\n    position: relative;\n    padding: 28px 24px;\n    box-shadow: 0 4px 15px rgb(0 0 0 / 8%);\n    transition: transform 0.25s ease;\n    text-align: left;\n    align-items: start;\n}\n\n.otc-process-section .process-card:hover {\n    transform: translateY(-3px);\n}\n\n.otc-process-section .process-num {\n    font-size: 36px;\n    font-weight: 800;\n    color: #D1AA67;\n    margin-bottom: 12px;\n    font-weight: 800;\n    color: #D3B06C;\n    margin-bottom: 12px;\n}\n\n.process-card h4 {\n    font-size: 15px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 8px 0;\n}\n\n.process-card p {\n    font-size: 13.5px;\n    color: #6B7280;\n    line-height: 1.5;\n    margin: 0;\n}\n\n\n/* ==========================================================================\n   5. CTA BANNER (\"Partner with a Trusted OTC Desk\")\n   ========================================================================== */\n.partner-cta-section {\n    margin-bottom: 20px;\n}\n\n.partner-cta-card {\n    background: url('../../../../public/images/otc_service-img/octdesk_cta.jpg') no-repeat center center / cover, #FFFDF8;\n    border: 1px solid #8b6b352e;\n    border-radius: 24px;\n    padding: 50px 30px;\n    min-height: 282px;\n    text-align: center;\n    box-shadow: 0 1px 12px rgb(0 0 0 / 15%);\n}\n\n.partner-cta-card h2 {\n    font-size: 28px;\n    font-weight: 700;\n    color: #111827;\n    margin: 0 0 12px 0;\n}\n\n.partner-cta-card p {\n    font-size: 15px;\n    color: #6B7280;\n    max-width: 600px;\n    margin: 0 auto 28px auto;\n    line-height: 1.6;\n}\n\n.btn-contact-desk {\n    display: inline-flex;\n    align-items: center;\n    justify-content: center;\n    padding: 14px 36px;\n    background-color: #D1AA67;\n    color: #FFFFFF;\n    font-size: 15px;\n    font-weight: 600;\n    border: none;\n    border-radius: 50px;\n    cursor: pointer;\n    box-shadow: 0 4px 14px rgba(211, 176, 108, 0.3);\n    transition: all 0.25s ease;\n    text-decoration: none;\n}\n\n.btn-contact-desk:hover {\n    background-color: #C09D5B;\n    transform: translateY(-2px);\n    color: #fff;\n}\n\n\n/* ==========================================================================\n   RESPONSIVE ADJUSTMENTS\n   ========================================================================== */\n@media (max-width: 1500px) {\n\n    .otc-service-container {\n        max-width: 95%;\n    }\n\n    .otc-service-hero-title {\n        font-size: 60px;\n    }\n\n}\n\n\n@media (max-width: 1200px) {\n\n\n    .otc-service-hero-right {\n        width: 450px;\n        max-width: 100%;\n        justify-content: center;\n    }\n\n    .otc-service-hero-title {\n        font-size: 48px;\n    }\n\n    .otc-service-hero-desc {\n        font-size: 16px;\n        margin: 0 0 24px 0;\n    }\n\n    .otc-service-hero-btns a {\n        font-size: 14px;\n        padding: 10px 28px;\n    }\n\n    .our-otc-title {\n        font-size: 32px;\n    }\n\n\n    .otc-process-section {\n        min-height: 500px;\n    }\n\n\n}\n\n@media (max-width: 768px) {\n\n\n    .detailed-services-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n\n    .process-grid-4col {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .otc-service-hero-title {\n        font-size: 38px;\n    }\n\n    .mini-services-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n\n    .detailed-services-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .process-grid-4col {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .otc-service-hero-right {\n        width: 330px;\n    }\n\n    .otc-process-section {\n        min-height: 500px;\n        margin-bottom: 40px;\n        padding-top: 40px;\n    }\n\n    .otc-service-hero-title {\n        font-size: 32px;\n        margin-bottom: 15px;\n    }\n\n    .otc-service-hero-desc {\n        font-size: 15px;\n        margin: 0 0 20px 0;\n    }\n\n    .otc_hero_section {\n        margin-bottom: 35px;\n    }\n\n    .our-otc-title {\n        font-size: 24px;\n    }\n\n    .detailed-services-grid {\n        grid-template-columns: 1fr 1fr;\n    }\n\n    .otc-service-container {\n        width: 100%;\n    }\n\n    .process-title {\n        font-size: 24px;\n        margin: 0 0 20px 0px;\n    }\n\n    .otc-process-section .process-num {\n        font-size: 36px;\n        position: absolute;\n        left: 19px;\n        top: 14px;\n        margin: 0px;\n        color: #d3b06ca6;\n    }\n\n    .otc-process-section .process-card h4 {\n        padding-left: 48px;\n        font-size: 18px;\n    }\n\n    .otc-process-section .process-card p {\n        font-size: 14px;\n        padding-left: 50px;\n    }\n\n    .otc-process-section .process-card {\n        border-radius: 15px;\n        padding: 24px;\n    }\n\n}\n\n@media (max-width: 767px) {\n\n    .otc-service-hero {\n        flex-direction: column;\n        text-align: center;\n        gap: 20px;\n        padding: 30px 0px 0px;\n    }\n\n    .otc-service-hero-title {\n        font-size: 26px;\n    }\n\n    .otc-service-hero-desc {\n        margin: 0 0 15px 0;\n    }\n\n    .otc-service-hero-btns {\n        justify-content: center;\n    }\n\n    .otc-service-hero-right {\n        width: 300px;\n    }\n\n    .otc_hero_section {\n        margin-bottom: 30px;\n    }\n\n    .our-otc-services-section {\n        margin-bottom: 40px;\n    }\n\n    .otcservices_list {\n        padding: 35px 0px;\n    }\n\n    .service-feature-card {\n        padding: 22px;\n    }\n\n    .partner-cta-card h2 {\n        font-size: 24px;\n    }\n\n    .btn-contact-desk {\n        padding: 10px 30px;\n        font-size: 13px;\n    }\n\n    .otc-service-page {\n        padding: 0px 0 30px 0;\n    }\n\n\n}\n\n\n@media (max-width:480px) {\n\n    .mini-services-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n\n    .feature-icon-box {\n        width: 38px;\n        height: 38px;\n        border-radius: 10px;\n        margin: 0 auto;\n    }\n\n    .partner-cta-card p {\n        font-size: 14px;\n        margin: 0 auto 15px auto;\n    }\n\n    .service-feature-card h3 {\n        margin: 18px 0 5px 0;\n    }\n\n    .mini-icon-box {\n        width: 38px;\n        height: 38px;\n        border-radius: 10px;\n    }\n\n    .otc-process-section {\n        padding-top: 30px;\n    }\n\n    .process-title {\n        font-size: 22px;\n        margin: 0 0 16px 0px;\n    }\n\n    .otc-process-section .process-num {\n        font-size: 32px;\n    }\n\n    .service-feature-card {\n        text-align: center;\n    }\n\n    .detailed-services-grid {\n        grid-template-columns: 1fr;\n        gap: 18px;\n\n    }\n\n    .our-otc-title {\n        font-size: 22px;\n        margin-bottom: 15px;\n    }\n\n    .process-grid-4col {\n        grid-template-columns: 1fr;\n    }\n\n    .partner-cta-card {\n        border-radius: 18px;\n        padding: 36px 24px;\n        min-height: 100%;\n    }\n\n    .partner-cta-card h2 {\n        font-size: 22px;\n        margin: 0 0 8px 0;\n    }\n\n}\n\nbody:not(.light_theme) .otc-service-page {\n    background-color: #181a20;\n    color: #eaecef;\n}\n\nbody:not(.light_theme) .otc_hero_section,\nbody:not(.light_theme) .partner-cta-card {\n    background-color: #181a20;\n    background-image: none;\n}\n\nbody:not(.light_theme) .otc_hero_section::before {\n    content: \"\";\n    position: absolute;\n    inset: 0;\n    pointer-events: none;\n    z-index: 0;\n    background:\n        repeating-conic-gradient(\n            from -18deg at 72% -8%,\n            rgba(211, 176, 108, 0.18) 0deg 3.5deg,\n            transparent 3.5deg 12deg\n        ),\n        radial-gradient(ellipse 70% 50% at 70% 0%, rgba(211, 176, 108, 0.22) 0%, rgba(24, 26, 32, 0) 68%);\n}\n\nbody:not(.light_theme) .otc-service-hero-title,\nbody:not(.light_theme) .our-otc-title,\nbody:not(.light_theme) .process-title,\nbody:not(.light_theme) .partner-cta-card h2,\nbody:not(.light_theme) .service-feature-card h3,\nbody:not(.light_theme) .mini-service-card span,\nbody:not(.light_theme) .process-card h4 {\n    color: #eaecef;\n}\n\nbody:not(.light_theme) .otc-service-hero-desc,\nbody:not(.light_theme) .link-learn-more,\nbody:not(.light_theme) .service-feature-card p,\nbody:not(.light_theme) .partner-cta-card p,\nbody:not(.light_theme) .process-card p {\n    color: #84888c;\n}\n\nbody:not(.light_theme) .mini-service-card,\nbody:not(.light_theme) .service-feature-card,\nbody:not(.light_theme) .otc-process-section .process-card {\n    background-color: #1e2329;\n    border-color: #2b3139;\n    box-shadow: none;\n}\n\nbody:not(.light_theme) .mini-service-card:hover {\n    background-color: #252a34;\n    border-color: #d3b06c;\n}\n\nbody:not(.light_theme) .otcservices_list {\n    background-color: #0b0e11;\n}\n\nbody:not(.light_theme) .otc-process-section {\n    background: linear-gradient(90deg, #1a1610 0%, #181a20 49%, #1a1610 100%);\n}\n\nbody:not(.light_theme) .mini-icon-box {\n    background-color: #2b2418;\n}\n\nbody:not(.light_theme) .partner-cta-card {\n    background-color: #1e2329;\n    border-color: #2b3139;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
